import { Component } from "@angular/core";
import { DialogService } from "src/app/core/services/dialog.service";
import { SpinnerService } from "src/app/core/services/spinner.service";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"]
})
export class ConfirmDialogComponent {

  constructor(protected dialogService: DialogService,
    protected spinnerService: SpinnerService) {
  }

}
